import {MenuStrategy} from "../MenuStrategy";

export class LoginMenuStrategy extends MenuStrategy {
   constructor() {
    super('Login', 'Accesso al sistema', 'app-user-login');
  }
}
